import serviceImg from "../../../assets/Home-Page-Assets/servicesImg.png";
import Button from "../../../components/Buttons/Button";
import Header from "../../../components/Headers/Header";

const serviceLinks = [
  { text: "Web Development", page: "/our-services" },
  { text: "Mobile Development", page: "/our-services" },
  { text: "Digital Marketing", page: "/our-services" },
  { text: "IT Support and Maintenance", page: "/our-services" },
  { text: "IT Consulting", page: "/our-services" },
  { text: "Graphic Design", page: "/our-services" },
];

const ServicesSection = () => {
  return (
    <div className="service-block">
      <Header
        headerTitle="Services"
        headerContent="At Belsoft Systems Ltd, we offer a range of services tailored to
                meet diverse technological needs for businesses, individuals,
                and clients alike."
      />
      <div className="service-body">
        <div className="container">
          <div className="service-img">
            <img src={serviceImg} alt="Belsoft services illustration" />
          </div>
          <div className="service-buttons">
            {serviceLinks.map((service) => (
              <Button key={service.text} text={service.text} page={service.page} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
